var React = require('react');

function MissingImage (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#f3f3f3"},[React.createElement("path",{"d":"M59.993 4.001l.007.007v47.986l-.007.007H4.007L4 51.994V4.008l.007-.007h55.986zm.007-4H4c-2.2 0-4 1.8-4 4v48c0 2.2 1.8 4 4 4h56c2.2 0 4-1.8 4-4v-48c0-2.2-1.8-4-4-4z","key":0}),React.createElement("path",{"d":"M52 14.001a6 6 0 11-12 0 6 6 0 0112 0zm4 34H8v-8l14-24 16 20h4l14-12z","key":1})]));
}

MissingImage.defaultProps = {"version":"1.2","baseProfile":"tiny","id":"Missing","x":"0","y":"0","viewBox":"0 0 64 57"};

module.exports = MissingImage;

MissingImage.default = MissingImage;
